<template>
	<bg-modal
		:value="isOpen"
		title="Yakin ingin hapus member?"
		description="Anda akan menghapus member dari role. "
		desktop-size="sm"
		:closable="false"
		:close-on-click-backdrop="false"
	>
		<template #footer>
			<div class="flex justify-end">
				<bg-button @click="closeModal">Batal</bg-button>
				<bg-button
					:loading="isLoading"
					variant="primary"
					class="ml-16"
					@click="deleteRole"
					>Hapus</bg-button
				>
			</div>
		</template>
	</bg-modal>
</template>

<script>
import { BgModal, BgButton } from 'bangul-vue';
import roleManagementApi from '@admin_endpoints/role-management';

export default {
	name: 'DeleteMemberModal',

	components: {
		BgModal,
		BgButton,
	},

	props: {
		isOpen: {
			type: Boolean,
			required: true,
		},
		selectedMemberId: {
			type: [Number, String],
			default: null,
		},
		roleId: {
			type: [Number, String],
			required: true,
		},
	},

	data() {
		return {
			isLoading: false,
		};
	},

	methods: {
		closeModal() {
			this.$emit('update:isOpen', false);
			this.$emit('update:selectedMemberId', null);
		},

		async deleteRole() {
			if (this.selectedMemberId !== null) {
				this.isLoading = true;

				try {
					const { data } = await roleManagementApi.deleteMemberFromRole(
						this.roleId,
						this.selectedMemberId
					);

					if (data.status) {
						this.$emit('action-success-delete', this.selectedMemberId);
					} else {
						this.$emit('action-fail-delete');
					}
				} catch (error) {
					this.$emit('action-fail-delete', error);
				} finally {
					this.isLoading = false;
					this.closeModal();
				}
			}
		},
	},
};
</script>
